<glo-top-toolbar></glo-top-toolbar>
<glo-estudio-sidenav-loader></glo-estudio-sidenav-loader>
<ng-content></ng-content>
<glo-page-footer></glo-page-footer>
